var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.loading } },
    [
      _c(
        "a-row",
        { attrs: { type: "flex" } },
        [
          _c(
            "a-col",
            [_vm._t("buttonBefore", null, { target: _vm.getVM() })],
            2
          ),
          _c("a-col", [
            _vm.actionButton
              ? _c(
                  "div",
                  { staticClass: "action-button" },
                  [
                    _vm.buttonPermission("add")
                      ? _c(
                          "a-button-group",
                          [
                            _c(
                              "a-button",
                              {
                                attrs: {
                                  type: "primary",
                                  icon: "plus",
                                  disabled: _vm.disabled
                                },
                                on: { click: _vm.handleClickAdd }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.language["common.insertButton"])
                                )
                              ]
                            ),
                            _vm.addButtonSettings
                              ? _c(
                                  "a-popover",
                                  {
                                    attrs: {
                                      placement: "right",
                                      overlayClassName: "j-add-btn-settings"
                                    }
                                  },
                                  [
                                    _c(
                                      "a-row",
                                      {
                                        attrs: { slot: "title" },
                                        slot: "title"
                                      },
                                      [
                                        _c("a-col", { attrs: { span: 12 } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.language["common.chooseItem"]
                                            )
                                          )
                                        ]),
                                        _c(
                                          "a-col",
                                          {
                                            staticStyle: {
                                              "text-align": "right"
                                            },
                                            attrs: { span: 12 }
                                          },
                                          [
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: {
                                                  title:
                                                    _vm.language[
                                                      "common.saveDefault"
                                                    ]
                                                }
                                              },
                                              [
                                                _c("a-button", {
                                                  staticStyle: {
                                                    position: "relative",
                                                    left: "4px"
                                                  },
                                                  attrs: {
                                                    type: "link",
                                                    icon: "save",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.onAddButtonSettingsSave
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "template",
                                      { slot: "content" },
                                      [
                                        _c(
                                          "a-form-model",
                                          {
                                            attrs: {
                                              layout: "horizontal",
                                              labelCol: { span: 8 },
                                              wrapperCol: { span: 16 }
                                            }
                                          },
                                          [
                                            _c(
                                              "a-form-model-item",
                                              {
                                                attrs: {
                                                  label:
                                                    _vm.language[
                                                      "common.addLineCount"
                                                    ]
                                                }
                                              },
                                              [
                                                _c("a-input-number", {
                                                  attrs: { min: 1 },
                                                  model: {
                                                    value:
                                                      _vm.settings.addRowNum,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.settings,
                                                        "addRowNum",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "settings.addRowNum"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "a-form-model-item",
                                              {
                                                attrs: {
                                                  label:
                                                    _vm.language[
                                                      "common.addPosition"
                                                    ]
                                                }
                                              },
                                              [
                                                _c("a-input-number", {
                                                  attrs: {
                                                    min: 0,
                                                    max: _vm.rows.length
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.settings.addIndex,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.settings,
                                                        "addIndex",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "settings.addIndex"
                                                  }
                                                }),
                                                _c(
                                                  "p",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "12px",
                                                      color: "#aaa",
                                                      "line-height": "14px",
                                                      "text-align": "right",
                                                      margin: "0"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    0 = " +
                                                        _vm._s(
                                                          _vm.language[
                                                            "common.bottom"
                                                          ]
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _c("a-divider", {
                                              staticStyle: { margin: "8px 0" }
                                            }),
                                            _c(
                                              "a-checkbox",
                                              {
                                                model: {
                                                  value:
                                                    _vm.settings
                                                      .addScrollToBottom,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.settings,
                                                      "addScrollToBottom",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "settings.addScrollToBottom"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.language[
                                                      "common.addScrollBottom"
                                                    ]
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c("a-button", {
                                      attrs: {
                                        icon: "setting",
                                        type: "primary"
                                      }
                                    })
                                  ],
                                  2
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("span", { staticClass: "gap" }),
                    _vm.selectedRowIds.length > 0
                      ? [
                          _c(
                            "a-popconfirm",
                            {
                              attrs: {
                                title: _vm.language["common.deleteConfirmInfo"]
                              },
                              on: { confirm: _vm.handleConfirmDelete }
                            },
                            [
                              _vm.buttonPermission("batch_delete")
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: {
                                        type: _vm.deleteIconType,
                                        icon: "minus",
                                        disabled: _vm.disabled
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.language["common.delete"])
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c("span", { staticClass: "gap" })
                            ],
                            1
                          ),
                          _vm.showClearSelectButton
                            ? [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { icon: "delete" },
                                    on: { click: _vm.handleClickClearSelection }
                                  },
                                  [_vm._v(_vm._s(_vm.language["common.clear"]))]
                                ),
                                _c("span", { staticClass: "gap" })
                              ]
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]),
          _c("a-col", [_vm._t("buttonAfter", null, { target: _vm.getVM() })], 2)
        ],
        1
      ),
      _vm._t("actionButtonAfter", null, { target: _vm.getVM() }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.emptyDataShowList || (_vm.rows && _vm.rows.length),
              expression: "emptyDataShowList || (rows && rows.length)"
            }
          ],
          staticClass: "input-table",
          attrs: { id: _vm.caseId + "inputTable" }
        },
        [
          _c("div", { ref: "thead", staticClass: "thead" }, [
            _c(
              "div",
              { staticClass: "tr", style: { width: this.realTrWidth } },
              [
                _vm.dragSort
                  ? _c(
                      "div",
                      { staticClass: "td td-ds", style: _vm.style.tdLeft },
                      [_c("span")]
                    )
                  : _vm._e(),
                _vm.rowSelection
                  ? _c(
                      "div",
                      { staticClass: "td td-cb", style: _vm.style.tdLeft },
                      [
                        _c("a-checkbox", {
                          attrs: {
                            checked: _vm.getSelectAll,
                            indeterminate: _vm.getSelectIndeterminate
                          },
                          on: { change: _vm.handleChangeCheckedAll }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.rowNumber
                  ? _c(
                      "div",
                      { staticClass: "td td-num", style: _vm.style.tdLeft },
                      [_c("span", [_vm._v("#")])]
                    )
                  : _vm._e(),
                _vm._l(_vm.columns, function(col) {
                  return [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: col.type !== _vm.formTypes.hidden,
                            expression: "col.type !== formTypes.hidden"
                          }
                        ],
                        key: col.key,
                        staticClass: "td",
                        style: _vm.buildTdStyle(col)
                      },
                      [_c("span", [_vm._v(_vm._s(col.title))])]
                    )
                  ]
                })
              ],
              2
            )
          ]),
          _c(
            "div",
            {
              ref: "scrollView",
              staticClass: "scroll-view",
              style: { "max-height": _vm.maxHeight + "px" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "tbody",
                  style: _vm.tbodyStyle,
                  attrs: { id: _vm.caseId + "tbody" }
                },
                [
                  _c("div", {
                    staticClass: "tr-expand",
                    style:
                      "height:" +
                      _vm.getExpandHeight +
                      "px; z-index:" +
                      (_vm.loading ? "11" : "9") +
                      ";"
                  }),
                  _vm.rows.length === 0
                    ? _c("div", { staticClass: "tr-nodata" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.language["common.noData"]))
                        ])
                      ])
                    : _vm._e(),
                  _c(
                    "draggable",
                    {
                      attrs: { value: _vm.rows, handle: ".td-ds-icons" },
                      on: {
                        start: _vm.handleDragMoveStart,
                        end: _vm.handleDragMoveEnd
                      }
                    },
                    [
                      _vm._l(_vm.rows, function(row, rowIndex) {
                        return [
                          rowIndex >=
                            parseInt(
                              "" +
                                (_vm.scrollTop - _vm.rowHeight) / _vm.rowHeight
                            ) &&
                          parseInt("" + _vm.scrollTop / _vm.rowHeight) + 9 >
                            rowIndex
                            ? _c(
                                "div",
                                {
                                  key: row.id,
                                  staticClass: "tr",
                                  class:
                                    _vm.selectedRowIds.indexOf(row.id) !== -1
                                      ? "tr-checked"
                                      : "",
                                  style: _vm.buildTrStyle(rowIndex),
                                  attrs: {
                                    id: _vm.caseId + "tbody-tr-" + rowIndex,
                                    "data-idx": rowIndex
                                  },
                                  on: { click: _vm.handleClickTableRow }
                                },
                                [
                                  _vm.dragSort
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "td td-ds",
                                          style: _vm.style.tdLeft,
                                          on: {
                                            dblclick: function($event) {
                                              return _vm._handleRowInsertDown(
                                                rowIndex
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "a-dropdown",
                                            {
                                              attrs: {
                                                trigger: ["click"],
                                                getPopupContainer:
                                                  _vm.getParentContainer
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "td-ds-icons" },
                                                [
                                                  _c("a-icon", {
                                                    attrs: {
                                                      type: "align-left"
                                                    }
                                                  }),
                                                  _c("a-icon", {
                                                    attrs: {
                                                      type: "align-right"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "a-menu",
                                                {
                                                  attrs: { slot: "overlay" },
                                                  slot: "overlay"
                                                },
                                                [
                                                  _c(
                                                    "a-menu-item",
                                                    {
                                                      key: "0",
                                                      attrs: {
                                                        disabled: rowIndex === 0
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm._handleRowMoveUp(
                                                            rowIndex
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.language[
                                                            "common.moveUp"
                                                          ]
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "a-menu-item",
                                                    {
                                                      key: "1",
                                                      attrs: {
                                                        disabled:
                                                          rowIndex ===
                                                          _vm.rows.length - 1
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm._handleRowMoveDown(
                                                            rowIndex
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.language[
                                                            "common.moveDown"
                                                          ]
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm.sortInsertDown
                                                    ? _c("a-menu-divider")
                                                    : _vm._e(),
                                                  _vm.sortInsertDown
                                                    ? _c(
                                                        "a-menu-item",
                                                        {
                                                          key: "3",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm._handleRowInsertDown(
                                                                rowIndex
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.language[
                                                                "common.addOneLine"
                                                              ]
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.rowSelection
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "td td-cb",
                                          style: _vm.style.tdLeft
                                        },
                                        [
                                          _vm._l(["" + row.id], function(
                                            id,
                                            i
                                          ) {
                                            return [
                                              _c("a-checkbox", {
                                                key: i,
                                                attrs: {
                                                  id: id,
                                                  checked:
                                                    _vm.selectedRowIds.indexOf(
                                                      id
                                                    ) !== -1
                                                },
                                                on: {
                                                  change:
                                                    _vm.handleChangeLeftCheckbox
                                                }
                                              })
                                            ]
                                          })
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm.rowNumber
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "td td-num",
                                          style: _vm.style.tdLeft
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(rowIndex + 1))
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._l(_vm.columns, function(col) {
                                    return _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              col.type !== _vm.formTypes.hidden,
                                            expression:
                                              "col.type !== formTypes.hidden"
                                          }
                                        ],
                                        key: col.key,
                                        staticClass: "td",
                                        style: _vm.buildTdStyle(col)
                                      },
                                      [
                                        _vm._l(
                                          ["" + col.key + row.id],
                                          function(id, i) {
                                            return [
                                              col.type ===
                                                _vm.formTypes.input ||
                                              col.type ===
                                                _vm.formTypes.inputNumber
                                                ? _c(
                                                    "label",
                                                    { key: i },
                                                    [
                                                      _c(
                                                        "a-tooltip",
                                                        _vm._b(
                                                          {},
                                                          "a-tooltip",
                                                          _vm.buildInputTooltipProps(
                                                            row,
                                                            col,
                                                            id,
                                                            rowIndex
                                                          ),
                                                          false
                                                        ),
                                                        [
                                                          _vm.isEditRow(
                                                            row,
                                                            col
                                                          )
                                                            ? _c(
                                                                "input",
                                                                _vm._b(
                                                                  {
                                                                    attrs: {
                                                                      id: id,
                                                                      maxlength:
                                                                        col.maxLength,
                                                                      "data-input-number":
                                                                        col.type ===
                                                                        _vm
                                                                          .formTypes
                                                                          .inputNumber,
                                                                      placeholder: _vm.replaceProps(
                                                                        col,
                                                                        col.placeholder
                                                                      )
                                                                    },
                                                                    on: {
                                                                      blur: function(
                                                                        e
                                                                      ) {
                                                                        _vm.handleBlurCommono(
                                                                          e.target,
                                                                          rowIndex,
                                                                          row,
                                                                          col
                                                                        )
                                                                      },
                                                                      input: function(
                                                                        e
                                                                      ) {
                                                                        _vm.handleInputCommono(
                                                                          e.target,
                                                                          rowIndex,
                                                                          row,
                                                                          col
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  "input",
                                                                  _vm.buildProps(
                                                                    row,
                                                                    col
                                                                  ),
                                                                  false
                                                                )
                                                              )
                                                            : _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "j-td-span no-edit",
                                                                  class: {
                                                                    disabled: _vm.buildProps(
                                                                      row,
                                                                      col
                                                                    ).disabled
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleEditRow(
                                                                        row,
                                                                        col
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .inputValues[
                                                                        rowIndex
                                                                      ][col.key]
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : col.type ===
                                                  _vm.formTypes.checkbox
                                                ? [
                                                    _c(
                                                      "a-checkbox",
                                                      _vm._b(
                                                        {
                                                          key: i,
                                                          attrs: {
                                                            id: id,
                                                            checked:
                                                              _vm
                                                                .checkboxValues[
                                                                id
                                                              ]
                                                          },
                                                          on: {
                                                            change: function(
                                                              e
                                                            ) {
                                                              return _vm.handleChangeCheckboxCommon(
                                                                e,
                                                                row,
                                                                col
                                                              )
                                                            }
                                                          }
                                                        },
                                                        "a-checkbox",
                                                        _vm.buildProps(
                                                          row,
                                                          col
                                                        ),
                                                        false
                                                      )
                                                    )
                                                  ]
                                                : col.type ===
                                                  _vm.formTypes.select
                                                ? [
                                                    _c(
                                                      "a-tooltip",
                                                      _vm._b(
                                                        {},
                                                        "a-tooltip",
                                                        _vm.buildTooltipProps(
                                                          row,
                                                          col,
                                                          id
                                                        ),
                                                        false
                                                      ),
                                                      [
                                                        _vm.isEditRow(row, col)
                                                          ? _c(
                                                              "a-select",
                                                              _vm._b(
                                                                {
                                                                  key: i,
                                                                  staticStyle: {
                                                                    width:
                                                                      "100%"
                                                                  },
                                                                  attrs: {
                                                                    id: id,
                                                                    showSearch:
                                                                      "",
                                                                    "filter-option":
                                                                      _vm.filterOption,
                                                                    optionFilterProp:
                                                                      "children",
                                                                    value:
                                                                      _vm
                                                                        .selectValues[
                                                                        id
                                                                      ],
                                                                    options:
                                                                      col.options,
                                                                    disabled:
                                                                      col.disabled,
                                                                    getPopupContainer:
                                                                      _vm.getParentContainer,
                                                                    placeholder: _vm.replaceProps(
                                                                      col,
                                                                      col.placeholder
                                                                    ),
                                                                    filterOption: function(
                                                                      i,
                                                                      o
                                                                    ) {
                                                                      return _vm.handleSelectFilterOption(
                                                                        i,
                                                                        o,
                                                                        col
                                                                      )
                                                                    },
                                                                    maxTagCount: 1,
                                                                    allowClear:
                                                                      ""
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      v
                                                                    ) {
                                                                      return _vm.handleChangeSelectCommon(
                                                                        v,
                                                                        id,
                                                                        row,
                                                                        col
                                                                      )
                                                                    },
                                                                    search: function(
                                                                      v
                                                                    ) {
                                                                      return _vm.handleSearchSelect(
                                                                        v,
                                                                        id,
                                                                        row,
                                                                        col
                                                                      )
                                                                    },
                                                                    blur: function(
                                                                      v
                                                                    ) {
                                                                      return _vm.handleBlurSearch(
                                                                        v,
                                                                        id,
                                                                        row,
                                                                        col
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                "a-select",
                                                                _vm.buildProps(
                                                                  row,
                                                                  col
                                                                ),
                                                                false
                                                              )
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "j-td-span no-edit",
                                                                class: {
                                                                  disabled: _vm.buildProps(
                                                                    row,
                                                                    col
                                                                  ).disabled
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.handleEditRow(
                                                                      row,
                                                                      col
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getSelectTranslateText(
                                                                      _vm
                                                                        .selectValues[
                                                                        id
                                                                      ],
                                                                      row,
                                                                      col
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                : col.type ===
                                                  _vm.formTypes.sel_depart
                                                ? [
                                                    _c(
                                                      "a-tooltip",
                                                      _vm._b(
                                                        {},
                                                        "a-tooltip",
                                                        _vm.buildTooltipProps(
                                                          row,
                                                          col,
                                                          id
                                                        ),
                                                        false
                                                      ),
                                                      [
                                                        _vm.isEditRow(row, col)
                                                          ? _c(
                                                              "j-select-depart",
                                                              _vm._b(
                                                                {
                                                                  key: i,
                                                                  staticStyle: {
                                                                    width:
                                                                      "100%"
                                                                  },
                                                                  attrs: {
                                                                    id: id,
                                                                    value:
                                                                      _vm
                                                                        .departCompValues[
                                                                        id
                                                                      ],
                                                                    placeholder: _vm.replaceProps(
                                                                      col,
                                                                      col.placeholder
                                                                    ),
                                                                    "trigger-change": true,
                                                                    multi: true
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      v
                                                                    ) {
                                                                      return _vm.handleChangeDepartCommon(
                                                                        v,
                                                                        id,
                                                                        row,
                                                                        col
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                "j-select-depart",
                                                                _vm.buildProps(
                                                                  row,
                                                                  col
                                                                ),
                                                                false
                                                              )
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "j-td-span no-edit",
                                                                class: {
                                                                  disabled: _vm.buildProps(
                                                                    row,
                                                                    col
                                                                  ).disabled
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleEditRow(
                                                                      row,
                                                                      col
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .departCompValues[
                                                                      id
                                                                    ]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                : col.type ===
                                                  _vm.formTypes.sel_user
                                                ? [
                                                    _c(
                                                      "a-tooltip",
                                                      _vm._b(
                                                        {},
                                                        "a-tooltip",
                                                        _vm.buildTooltipProps(
                                                          row,
                                                          col,
                                                          id
                                                        ),
                                                        false
                                                      ),
                                                      [
                                                        _vm.isEditRow(row, col)
                                                          ? _c(
                                                              "j-select-user-by-dep",
                                                              _vm._b(
                                                                {
                                                                  key: i,
                                                                  staticStyle: {
                                                                    width:
                                                                      "100%"
                                                                  },
                                                                  attrs: {
                                                                    id: id,
                                                                    value:
                                                                      _vm
                                                                        .userCompValues[
                                                                        id
                                                                      ],
                                                                    placeholder: _vm.replaceProps(
                                                                      col,
                                                                      col.placeholder
                                                                    ),
                                                                    "trigger-change": true,
                                                                    multi: true
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      v
                                                                    ) {
                                                                      return _vm.handleChangeUserCommon(
                                                                        v,
                                                                        id,
                                                                        row,
                                                                        col
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                "j-select-user-by-dep",
                                                                _vm.buildProps(
                                                                  row,
                                                                  col
                                                                ),
                                                                false
                                                              )
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "j-td-span no-edit",
                                                                class: {
                                                                  disabled: _vm.buildProps(
                                                                    row,
                                                                    col
                                                                  ).disabled
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleEditRow(
                                                                      row,
                                                                      col
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .userCompValues[
                                                                      id
                                                                    ]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                : col.type ===
                                                    _vm.formTypes.date ||
                                                  col.type ===
                                                    _vm.formTypes.datetime
                                                ? [
                                                    _c(
                                                      "a-tooltip",
                                                      _vm._b(
                                                        {},
                                                        "a-tooltip",
                                                        _vm.buildTooltipProps(
                                                          row,
                                                          col,
                                                          id
                                                        ),
                                                        false
                                                      ),
                                                      [
                                                        _vm.isEditRow(row, col)
                                                          ? _c(
                                                              "j-date",
                                                              _vm._b(
                                                                {
                                                                  key: i,
                                                                  staticStyle: {
                                                                    width:
                                                                      "100%"
                                                                  },
                                                                  attrs: {
                                                                    id: id,
                                                                    value:
                                                                      _vm
                                                                        .jdateValues[
                                                                        id
                                                                      ],
                                                                    getCalendarContainer:
                                                                      _vm.getParentContainer,
                                                                    placeholder: _vm.replaceProps(
                                                                      col,
                                                                      col.placeholder
                                                                    ),
                                                                    "trigger-change": true,
                                                                    showTime:
                                                                      col.type ===
                                                                      _vm
                                                                        .formTypes
                                                                        .datetime,
                                                                    dateFormat:
                                                                      col.type ===
                                                                      _vm
                                                                        .formTypes
                                                                        .date
                                                                        ? "YYYY-MM-DD"
                                                                        : "YYYY-MM-DD HH:mm:ss",
                                                                    allowClear:
                                                                      ""
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      v
                                                                    ) {
                                                                      return _vm.handleChangeJDateCommon(
                                                                        v,
                                                                        id,
                                                                        row,
                                                                        col,
                                                                        col.type ===
                                                                          _vm
                                                                            .formTypes
                                                                            .datetime
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                "j-date",
                                                                _vm.buildProps(
                                                                  row,
                                                                  col
                                                                ),
                                                                false
                                                              )
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "j-td-span no-edit",
                                                                class: {
                                                                  disabled: _vm.buildProps(
                                                                    row,
                                                                    col
                                                                  ).disabled
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleEditRow(
                                                                      row,
                                                                      col
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .jdateValues[
                                                                      id
                                                                    ]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                : col.type ===
                                                  _vm.formTypes.input_pop
                                                ? [
                                                    _c(
                                                      "a-tooltip",
                                                      _vm._b(
                                                        {},
                                                        "a-tooltip",
                                                        _vm.buildTooltipProps(
                                                          row,
                                                          col,
                                                          id
                                                        ),
                                                        false
                                                      ),
                                                      [
                                                        _vm.isEditRow(row, col)
                                                          ? _c(
                                                              "j-input-pop",
                                                              _vm._b(
                                                                {
                                                                  key: i,
                                                                  staticStyle: {
                                                                    width:
                                                                      "100%"
                                                                  },
                                                                  attrs: {
                                                                    id: id,
                                                                    width: 300,
                                                                    height: 210,
                                                                    "pop-container":
                                                                      _vm.caseId +
                                                                      "tbody",
                                                                    value:
                                                                      _vm
                                                                        .jInputPopValues[
                                                                        id
                                                                      ],
                                                                    getCalendarContainer:
                                                                      _vm.getParentContainer,
                                                                    placeholder: _vm.replaceProps(
                                                                      col,
                                                                      col.placeholder
                                                                    )
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      v
                                                                    ) {
                                                                      return _vm.handleChangeJInputPopCommon(
                                                                        v,
                                                                        id,
                                                                        row,
                                                                        col
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                "j-input-pop",
                                                                _vm.buildProps(
                                                                  row,
                                                                  col
                                                                ),
                                                                false
                                                              )
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "j-td-span no-edit",
                                                                class: {
                                                                  disabled: _vm.buildProps(
                                                                    row,
                                                                    col
                                                                  ).disabled
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleEditRow(
                                                                      row,
                                                                      col
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .jInputPopValues[
                                                                      id
                                                                    ]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                : col.type ===
                                                  _vm.formTypes.upload
                                                ? _c(
                                                    "div",
                                                    { key: i },
                                                    [
                                                      _vm._l(
                                                        [
                                                          _vm.uploadValues[
                                                            id
                                                          ] || {}
                                                        ],
                                                        function(
                                                          file,
                                                          fileKey
                                                        ) {
                                                          return _vm
                                                            .uploadValues[id] !=
                                                            null
                                                            ? [
                                                                _c(
                                                                  "a-input",
                                                                  {
                                                                    key: fileKey,
                                                                    attrs: {
                                                                      readOnly: true,
                                                                      value:
                                                                        file.name
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "template",
                                                                      {
                                                                        staticStyle: {
                                                                          width:
                                                                            "30px"
                                                                        },
                                                                        slot:
                                                                          "addonBefore"
                                                                      },
                                                                      [
                                                                        file.status ===
                                                                        "uploading"
                                                                          ? _c(
                                                                              "a-tooltip",
                                                                              {
                                                                                attrs: {
                                                                                  title:
                                                                                    _vm
                                                                                      .language[
                                                                                      "common.uploading"
                                                                                    ] +
                                                                                    "(" +
                                                                                    Math.floor(
                                                                                      file.percent
                                                                                    ) +
                                                                                    "%)"
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "a-icon",
                                                                                  {
                                                                                    attrs: {
                                                                                      type:
                                                                                        "loading"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          : file.status ===
                                                                            "done"
                                                                          ? _c(
                                                                              "a-tooltip",
                                                                              {
                                                                                attrs: {
                                                                                  title:
                                                                                    _vm
                                                                                      .language[
                                                                                      "common.uploadSuccess"
                                                                                    ]
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "a-icon",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      color:
                                                                                        "#00db00"
                                                                                    },
                                                                                    attrs: {
                                                                                      type:
                                                                                        "check-circle"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          : _c(
                                                                              "a-tooltip",
                                                                              {
                                                                                attrs: {
                                                                                  title:
                                                                                    file.message ||
                                                                                    _vm
                                                                                      .language[
                                                                                      "common.uploadFailed"
                                                                                    ]
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "a-icon",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      color:
                                                                                        "red"
                                                                                    },
                                                                                    attrs: {
                                                                                      type:
                                                                                        "exclamation-circle"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    col.allowDownload !==
                                                                      false ||
                                                                    col.allowRemove !==
                                                                      false
                                                                      ? _c(
                                                                          "template",
                                                                          {
                                                                            staticStyle: {
                                                                              width:
                                                                                "30px"
                                                                            },
                                                                            slot:
                                                                              "addonAfter"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "a-dropdown",
                                                                              {
                                                                                attrs: {
                                                                                  trigger: [
                                                                                    "click"
                                                                                  ],
                                                                                  placement:
                                                                                    "bottomRight",
                                                                                  getPopupContainer:
                                                                                    _vm.getParentContainer
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "a-tooltip",
                                                                                  {
                                                                                    attrs: {
                                                                                      title:
                                                                                        _vm
                                                                                          .language[
                                                                                          "common.action"
                                                                                        ],
                                                                                      getPopupContainer:
                                                                                        _vm.getParentContainer
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    file.status !==
                                                                                    "uploading"
                                                                                      ? _c(
                                                                                          "a-icon",
                                                                                          {
                                                                                            staticStyle: {
                                                                                              cursor:
                                                                                                "pointer"
                                                                                            },
                                                                                            attrs: {
                                                                                              type:
                                                                                                "setting"
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                                _c(
                                                                                  "a-menu",
                                                                                  {
                                                                                    attrs: {
                                                                                      slot:
                                                                                        "overlay"
                                                                                    },
                                                                                    slot:
                                                                                      "overlay"
                                                                                  },
                                                                                  [
                                                                                    col.allowDownload !==
                                                                                      false &&
                                                                                    file.status &&
                                                                                    file.status !==
                                                                                      "error"
                                                                                      ? _c(
                                                                                          "a-menu-item",
                                                                                          {
                                                                                            on: {
                                                                                              click: function(
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.handleClickDownloadFile(
                                                                                                  id
                                                                                                )
                                                                                              }
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "span",
                                                                                              [
                                                                                                _c(
                                                                                                  "a-icon",
                                                                                                  {
                                                                                                    attrs: {
                                                                                                      type:
                                                                                                        "download"
                                                                                                    }
                                                                                                  }
                                                                                                ),
                                                                                                _vm._v(
                                                                                                  " " +
                                                                                                    _vm._s(
                                                                                                      _vm
                                                                                                        .language[
                                                                                                        "download"
                                                                                                      ]
                                                                                                    )
                                                                                                )
                                                                                              ],
                                                                                              1
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    col.allowRemove !==
                                                                                    false
                                                                                      ? _c(
                                                                                          "a-menu-item",
                                                                                          {
                                                                                            on: {
                                                                                              click: function(
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.handleClickDelFile(
                                                                                                  id
                                                                                                )
                                                                                              }
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "span",
                                                                                              [
                                                                                                _c(
                                                                                                  "a-icon",
                                                                                                  {
                                                                                                    attrs: {
                                                                                                      type:
                                                                                                        "delete"
                                                                                                    }
                                                                                                  }
                                                                                                ),
                                                                                                _vm._v(
                                                                                                  " " +
                                                                                                    _vm._s(
                                                                                                      _vm
                                                                                                        .language[
                                                                                                        "common.delete"
                                                                                                      ]
                                                                                                    )
                                                                                                )
                                                                                              ],
                                                                                              1
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e()
                                                                  ],
                                                                  2
                                                                )
                                                              ]
                                                            : _vm._e()
                                                        }
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          attrs: {
                                                            hidden:
                                                              _vm.uploadValues[
                                                                id
                                                              ] != null
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "a-tooltip",
                                                            _vm._b(
                                                              {},
                                                              "a-tooltip",
                                                              _vm.buildTooltipProps(
                                                                row,
                                                                col,
                                                                id
                                                              ),
                                                              false
                                                            ),
                                                            [
                                                              _c(
                                                                "a-upload",
                                                                _vm._b(
                                                                  {
                                                                    attrs: {
                                                                      name:
                                                                        "file",
                                                                      data: Object.assign(
                                                                        {},
                                                                        {
                                                                          isup: 1
                                                                        },
                                                                        col.data ||
                                                                          {}
                                                                      ),
                                                                      multiple: false,
                                                                      action:
                                                                        col.action,
                                                                      headers: _vm.uploadGetHeaders(
                                                                        row,
                                                                        col
                                                                      ),
                                                                      showUploadList: false,
                                                                      beforeUpload:
                                                                        _vm.beforeUpload
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        v
                                                                      ) {
                                                                        return _vm.handleChangeUpload(
                                                                          v,
                                                                          id,
                                                                          row,
                                                                          col
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  "a-upload",
                                                                  _vm.buildProps(
                                                                    row,
                                                                    col
                                                                  ),
                                                                  false
                                                                ),
                                                                [
                                                                  _c(
                                                                    "a-button",
                                                                    {
                                                                      attrs: {
                                                                        icon:
                                                                          "upload"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          col.placeholder
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    2
                                                  )
                                                : col.type ===
                                                  _vm.formTypes.popup
                                                ? [
                                                    _c(
                                                      "a-tooltip",
                                                      _vm._b(
                                                        {},
                                                        "a-tooltip",
                                                        _vm.buildTooltipProps(
                                                          row,
                                                          col,
                                                          id
                                                        ),
                                                        false
                                                      ),
                                                      [
                                                        _vm.isEditRow(row, col)
                                                          ? _c(
                                                              "j-popup",
                                                              _vm._b(
                                                                {
                                                                  key: i,
                                                                  staticStyle: {
                                                                    width:
                                                                      "100%"
                                                                  },
                                                                  attrs: {
                                                                    id: id,
                                                                    placeholder: _vm.replaceProps(
                                                                      col,
                                                                      col.placeholder
                                                                    ),
                                                                    value: _vm.getPopupValue(
                                                                      id
                                                                    ),
                                                                    field:
                                                                      col.field ||
                                                                      col.key,
                                                                    "org-fields":
                                                                      col.orgFields,
                                                                    "dest-fields":
                                                                      col.destFields,
                                                                    code:
                                                                      col.popupCode,
                                                                    groupId:
                                                                      _vm.caseId,
                                                                    param:
                                                                      col.param,
                                                                    sorter:
                                                                      col.sorter
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      value,
                                                                      others
                                                                    ) {
                                                                      return _vm.popupCallback(
                                                                        value,
                                                                        others,
                                                                        id,
                                                                        row,
                                                                        col,
                                                                        rowIndex
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                "j-popup",
                                                                _vm.buildProps(
                                                                  row,
                                                                  col
                                                                ),
                                                                false
                                                              )
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "j-td-span no-edit",
                                                                class: {
                                                                  disabled: _vm.buildProps(
                                                                    row,
                                                                    col
                                                                  ).disabled
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleEditRow(
                                                                      row,
                                                                      col
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getPopupValue(
                                                                      id
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                : col.type ===
                                                  _vm.formTypes.file
                                                ? _c(
                                                    "div",
                                                    { key: i },
                                                    [
                                                      _vm._l(
                                                        [
                                                          _vm.uploadValues[
                                                            id
                                                          ] || {}
                                                        ],
                                                        function(
                                                          file,
                                                          fileKey
                                                        ) {
                                                          return col.multiple
                                                            ? [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    key: fileKey,
                                                                    staticStyle: {
                                                                      position:
                                                                        "relative"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a-space",
                                                                      [
                                                                        _vm.isShowFile &&
                                                                        (_vm.IsDetail(
                                                                          row.id
                                                                        ) ||
                                                                          _vm.isDirector(
                                                                            row.id
                                                                          ))
                                                                          ? _c(
                                                                              "div"
                                                                            )
                                                                          : _vm.is162(
                                                                              row.id
                                                                            ) ||
                                                                            !_vm.isFactorEqual(
                                                                              row.id
                                                                            )
                                                                          ? _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "a",
                                                                                  {
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.handleMoreOperationS162(
                                                                                          id,
                                                                                          col,
                                                                                          col
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm
                                                                                          .language[
                                                                                          "common.look"
                                                                                        ]
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm.isShowFile &&
                                                                            !_vm.enableEdit(
                                                                              row.id
                                                                            )
                                                                          ? _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "a",
                                                                                  {
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.handleMoreOperation(
                                                                                          id,
                                                                                          col,
                                                                                          col
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm
                                                                                          .language[
                                                                                          "common.look"
                                                                                        ]
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "a",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      "margin-right":
                                                                                        "10px"
                                                                                    },
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.handleMoreOperation(
                                                                                          id,
                                                                                          col,
                                                                                          col
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.uploadValueIsNull(
                                                                                          _vm
                                                                                            .uploadValues[
                                                                                            id
                                                                                          ]
                                                                                        )
                                                                                          ? col.disabled ==
                                                                                            true
                                                                                            ? _vm
                                                                                                .language[
                                                                                                "common.look"
                                                                                              ]
                                                                                            : _vm
                                                                                                .language[
                                                                                                "common.edit"
                                                                                              ]
                                                                                          : col.disabled ==
                                                                                            true
                                                                                          ? ""
                                                                                          : _vm
                                                                                              .language[
                                                                                              "common.uploadButton"
                                                                                            ]
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm.uploadValueIsNull(
                                                                                  _vm
                                                                                    .uploadValues[
                                                                                    id
                                                                                  ]
                                                                                ) &&
                                                                                col.disabled ==
                                                                                  false
                                                                                  ? _c(
                                                                                      "a",
                                                                                      {
                                                                                        on: {
                                                                                          click: function(
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.handleClickDelFile(
                                                                                              id
                                                                                            )
                                                                                          }
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm
                                                                                              .language[
                                                                                              "common.delete"
                                                                                            ]
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e()
                                                                              ]
                                                                            )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            : [
                                                                _vm._l(
                                                                  [
                                                                    _vm
                                                                      .uploadValues[
                                                                      id
                                                                    ] || {}
                                                                  ],
                                                                  function(
                                                                    file,
                                                                    fileKey
                                                                  ) {
                                                                    return _vm
                                                                      .uploadValues[
                                                                      id
                                                                    ] != null
                                                                      ? [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              key: fileKey,
                                                                              staticStyle: {
                                                                                position:
                                                                                  "relative"
                                                                              }
                                                                            },
                                                                            [
                                                                              file.status ===
                                                                              "uploading"
                                                                                ? _c(
                                                                                    "a-tooltip",
                                                                                    {
                                                                                      attrs: {
                                                                                        title:
                                                                                          _vm
                                                                                            .language[
                                                                                            "common.uploading"
                                                                                          ] +
                                                                                          "(" +
                                                                                          Math.floor(
                                                                                            file.percent
                                                                                          ) +
                                                                                          "%)"
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "a-icon",
                                                                                        {
                                                                                          staticStyle: {
                                                                                            color:
                                                                                              "red"
                                                                                          },
                                                                                          attrs: {
                                                                                            type:
                                                                                              "loading"
                                                                                          }
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticStyle: {
                                                                                            color:
                                                                                              "red",
                                                                                            "margin-left":
                                                                                              "5px"
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              file.status
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                : file.status ===
                                                                                  "done"
                                                                                ? _c(
                                                                                    "a-tooltip",
                                                                                    {
                                                                                      attrs: {
                                                                                        title:
                                                                                          file.name
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "a-icon",
                                                                                        {
                                                                                          attrs: {
                                                                                            type:
                                                                                              "paper-clip"
                                                                                          }
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticStyle: {
                                                                                            "margin-left":
                                                                                              "5px"
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              _vm.getEllipsisWord(
                                                                                                file.name,
                                                                                                5
                                                                                              )
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                : _c(
                                                                                    "a-tooltip",
                                                                                    {
                                                                                      attrs: {
                                                                                        title:
                                                                                          file.message ||
                                                                                          _vm
                                                                                            .language[
                                                                                            "common.uploadFailed"
                                                                                          ]
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "a-icon",
                                                                                        {
                                                                                          staticStyle: {
                                                                                            color:
                                                                                              "red"
                                                                                          },
                                                                                          attrs: {
                                                                                            type:
                                                                                              "exclamation-circle"
                                                                                          }
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticStyle: {
                                                                                            "margin-left":
                                                                                              "5px"
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              _vm.getEllipsisWord(
                                                                                                file.name,
                                                                                                5
                                                                                              )
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                              [
                                                                                _c(
                                                                                  "a-dropdown",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      "margin-left":
                                                                                        "10px"
                                                                                    },
                                                                                    attrs: {
                                                                                      trigger: [
                                                                                        "click"
                                                                                      ],
                                                                                      placement:
                                                                                        "bottomRight",
                                                                                      getPopupContainer:
                                                                                        _vm.getParentContainer
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm.isShowDownloadButton
                                                                                      ? _c(
                                                                                          "a-tooltip",
                                                                                          {
                                                                                            attrs: {
                                                                                              title:
                                                                                                _vm
                                                                                                  .language[
                                                                                                  "common.action"
                                                                                                ],
                                                                                              getPopupContainer:
                                                                                                _vm.getParentContainer
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            file.status !==
                                                                                              "uploading" &&
                                                                                            _vm.isShowDownloadButton
                                                                                              ? _c(
                                                                                                  "a-icon",
                                                                                                  {
                                                                                                    staticStyle: {
                                                                                                      cursor:
                                                                                                        "pointer"
                                                                                                    },
                                                                                                    attrs: {
                                                                                                      type:
                                                                                                        "setting"
                                                                                                    }
                                                                                                  }
                                                                                                )
                                                                                              : _vm._e()
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      : _c(
                                                                                          "a-tooltip",
                                                                                          {
                                                                                            attrs: {
                                                                                              title:
                                                                                                _vm
                                                                                                  .language[
                                                                                                  "common.fileUp"
                                                                                                ],
                                                                                              getPopupContainer:
                                                                                                _vm.getParentContainer
                                                                                            },
                                                                                            on: {
                                                                                              click: function(
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.handleMoreOperation(
                                                                                                  id,
                                                                                                  col,
                                                                                                  col
                                                                                                )
                                                                                              }
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            file.status !==
                                                                                              "uploading" &&
                                                                                            !_vm.isShowDownloadButton
                                                                                              ? _c(
                                                                                                  "a-icon",
                                                                                                  {
                                                                                                    staticStyle: {
                                                                                                      cursor:
                                                                                                        "pointer"
                                                                                                    },
                                                                                                    attrs: {
                                                                                                      type:
                                                                                                        "upload"
                                                                                                    }
                                                                                                  }
                                                                                                )
                                                                                              : _vm._e()
                                                                                          ],
                                                                                          1
                                                                                        ),
                                                                                    _vm.isShowDownloadButton
                                                                                      ? _c(
                                                                                          "a-menu",
                                                                                          {
                                                                                            attrs: {
                                                                                              slot:
                                                                                                "overlay"
                                                                                            },
                                                                                            slot:
                                                                                              "overlay"
                                                                                          },
                                                                                          [
                                                                                            col.allowDownload !==
                                                                                            false
                                                                                              ? _c(
                                                                                                  "a-menu-item",
                                                                                                  {
                                                                                                    on: {
                                                                                                      click: function(
                                                                                                        $event
                                                                                                      ) {
                                                                                                        return _vm.handleClickDownFileByUrl(
                                                                                                          id
                                                                                                        )
                                                                                                      }
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "span",
                                                                                                      [
                                                                                                        _c(
                                                                                                          "a-icon",
                                                                                                          {
                                                                                                            attrs: {
                                                                                                              type:
                                                                                                                "download"
                                                                                                            }
                                                                                                          }
                                                                                                        ),
                                                                                                        _vm._v(
                                                                                                          " " +
                                                                                                            _vm._s(
                                                                                                              _vm
                                                                                                                .language[
                                                                                                                "download"
                                                                                                              ]
                                                                                                            )
                                                                                                        )
                                                                                                      ],
                                                                                                      1
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              : _vm._e(),
                                                                                            _vm.isShowDeleteButton
                                                                                              ? _c(
                                                                                                  "a-menu-item",
                                                                                                  {
                                                                                                    on: {
                                                                                                      click: function(
                                                                                                        $event
                                                                                                      ) {
                                                                                                        return _vm.handleClickDelFile(
                                                                                                          id
                                                                                                        )
                                                                                                      }
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "span",
                                                                                                      [
                                                                                                        _c(
                                                                                                          "a-icon",
                                                                                                          {
                                                                                                            attrs: {
                                                                                                              type:
                                                                                                                "delete"
                                                                                                            }
                                                                                                          }
                                                                                                        ),
                                                                                                        _vm._v(
                                                                                                          " " +
                                                                                                            _vm._s(
                                                                                                              _vm
                                                                                                                .language[
                                                                                                                "common.delete"
                                                                                                              ]
                                                                                                            )
                                                                                                        )
                                                                                                      ],
                                                                                                      1
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              : _vm._e(),
                                                                                            _vm.isShowMoreButton
                                                                                              ? _c(
                                                                                                  "a-menu-item",
                                                                                                  {
                                                                                                    on: {
                                                                                                      click: function(
                                                                                                        $event
                                                                                                      ) {
                                                                                                        return _vm.handleMoreOperation(
                                                                                                          id,
                                                                                                          col,
                                                                                                          col
                                                                                                        )
                                                                                                      }
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "span",
                                                                                                      [
                                                                                                        _c(
                                                                                                          "a-icon",
                                                                                                          {
                                                                                                            attrs: {
                                                                                                              type:
                                                                                                                "bars"
                                                                                                            }
                                                                                                          }
                                                                                                        ),
                                                                                                        _vm._v(
                                                                                                          " " +
                                                                                                            _vm._s(
                                                                                                              _vm
                                                                                                                .language[
                                                                                                                "common.more"
                                                                                                              ]
                                                                                                            )
                                                                                                        )
                                                                                                      ],
                                                                                                      1
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              : _vm._e()
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ]
                                                                            ],
                                                                            2
                                                                          )
                                                                        ]
                                                                      : _vm._e()
                                                                  }
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    attrs: {
                                                                      hidden:
                                                                        _vm
                                                                          .uploadValues[
                                                                          id
                                                                        ] !=
                                                                        null
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a-tooltip",
                                                                      _vm._b(
                                                                        {},
                                                                        "a-tooltip",
                                                                        _vm.buildTooltipProps(
                                                                          row,
                                                                          col,
                                                                          id
                                                                        ),
                                                                        false
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "a-upload",
                                                                          _vm._b(
                                                                            {
                                                                              attrs: {
                                                                                name:
                                                                                  "file",
                                                                                data: {
                                                                                  isup: 1
                                                                                },
                                                                                multiple: false,
                                                                                action: _vm.getUploadAction(
                                                                                  col.action
                                                                                ),
                                                                                headers: _vm.uploadGetHeaders(
                                                                                  row,
                                                                                  col
                                                                                ),
                                                                                showUploadList: false,
                                                                                beforeUpload:
                                                                                  col.beforeUpload ||
                                                                                  _vm.beforeUpload
                                                                              },
                                                                              on: {
                                                                                change: function(
                                                                                  v
                                                                                ) {
                                                                                  return _vm.handleChangeUpload(
                                                                                    v,
                                                                                    id,
                                                                                    row,
                                                                                    col
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            "a-upload",
                                                                            _vm.buildProps(
                                                                              row,
                                                                              col
                                                                            ),
                                                                            false
                                                                          ),
                                                                          [
                                                                            _c(
                                                                              "a-button",
                                                                              {
                                                                                attrs: {
                                                                                  icon:
                                                                                    "upload"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .language[
                                                                                      "common.fileUp"
                                                                                    ]
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                : col.type ===
                                                  _vm.formTypes.image
                                                ? _c(
                                                    "div",
                                                    { key: i },
                                                    [
                                                      _vm._l(
                                                        [
                                                          _vm.uploadValues[
                                                            id
                                                          ] || {}
                                                        ],
                                                        function(
                                                          file,
                                                          fileKey
                                                        ) {
                                                          return _vm
                                                            .uploadValues[id] !=
                                                            null
                                                            ? [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    key: fileKey,
                                                                    staticStyle: {
                                                                      position:
                                                                        "relative"
                                                                    }
                                                                  },
                                                                  [
                                                                    !_vm
                                                                      .uploadValues[
                                                                      id
                                                                    ] ||
                                                                    !(
                                                                      _vm
                                                                        .uploadValues[
                                                                        id
                                                                      ][
                                                                        "url"
                                                                      ] ||
                                                                      _vm
                                                                        .uploadValues[
                                                                        id
                                                                      ][
                                                                        "path"
                                                                      ] ||
                                                                      _vm
                                                                        .uploadValues[
                                                                        id
                                                                      ][
                                                                        "message"
                                                                      ]
                                                                    )
                                                                      ? [
                                                                          _c(
                                                                            "a-icon",
                                                                            {
                                                                              attrs: {
                                                                                type:
                                                                                  "loading"
                                                                              }
                                                                            }
                                                                          )
                                                                        ]
                                                                      : _vm
                                                                          .uploadValues[
                                                                          id
                                                                        ][
                                                                          "path"
                                                                        ]
                                                                      ? [
                                                                          _c(
                                                                            "img",
                                                                            {
                                                                              staticClass:
                                                                                "j-editable-image",
                                                                              attrs: {
                                                                                src: _vm.getCellImageView(
                                                                                  id
                                                                                ),
                                                                                alt:
                                                                                  "无图片"
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.handleMoreOperation(
                                                                                    id,
                                                                                    "img",
                                                                                    col
                                                                                  )
                                                                                }
                                                                              }
                                                                            }
                                                                          )
                                                                        ]
                                                                      : _c(
                                                                          "a-tooltip",
                                                                          {
                                                                            attrs: {
                                                                              title:
                                                                                file.message ||
                                                                                _vm
                                                                                  .language[
                                                                                  "common.uploadFailed"
                                                                                ]
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.handleClickShowImageError(
                                                                                  id
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "a-icon",
                                                                              {
                                                                                staticStyle: {
                                                                                  color:
                                                                                    "red"
                                                                                },
                                                                                attrs: {
                                                                                  type:
                                                                                    "exclamation-circle"
                                                                                }
                                                                              }
                                                                            )
                                                                          ],
                                                                          1
                                                                        ),
                                                                    [
                                                                      _c(
                                                                        "a-dropdown",
                                                                        {
                                                                          staticStyle: {
                                                                            "margin-left":
                                                                              "10px"
                                                                          },
                                                                          attrs: {
                                                                            trigger: [
                                                                              "click"
                                                                            ],
                                                                            placement:
                                                                              "bottomRight",
                                                                            getPopupContainer:
                                                                              _vm.getParentContainer
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "a-tooltip",
                                                                            {
                                                                              attrs: {
                                                                                title:
                                                                                  _vm
                                                                                    .language[
                                                                                    "common.action"
                                                                                  ],
                                                                                getPopupContainer:
                                                                                  _vm.getParentContainer
                                                                              }
                                                                            },
                                                                            [
                                                                              file.status !==
                                                                              "uploading"
                                                                                ? _c(
                                                                                    "a-icon",
                                                                                    {
                                                                                      staticStyle: {
                                                                                        cursor:
                                                                                          "pointer"
                                                                                      },
                                                                                      attrs: {
                                                                                        type:
                                                                                          "setting"
                                                                                      }
                                                                                    }
                                                                                  )
                                                                                : _vm._e()
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _c(
                                                                            "a-menu",
                                                                            {
                                                                              attrs: {
                                                                                slot:
                                                                                  "overlay"
                                                                              },
                                                                              slot:
                                                                                "overlay"
                                                                            },
                                                                            [
                                                                              col.allowDownload !==
                                                                              false
                                                                                ? _c(
                                                                                    "a-menu-item",
                                                                                    {
                                                                                      on: {
                                                                                        click: function(
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.handleClickDownFileByUrl(
                                                                                            id
                                                                                          )
                                                                                        }
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        [
                                                                                          _c(
                                                                                            "a-icon",
                                                                                            {
                                                                                              attrs: {
                                                                                                type:
                                                                                                  "download"
                                                                                              }
                                                                                            }
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " " +
                                                                                              _vm._s(
                                                                                                _vm
                                                                                                  .language[
                                                                                                  "download"
                                                                                                ]
                                                                                              )
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              _c(
                                                                                "a-menu-item",
                                                                                {
                                                                                  on: {
                                                                                    click: function(
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.handleClickDelFile(
                                                                                        id
                                                                                      )
                                                                                    }
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    [
                                                                                      _c(
                                                                                        "a-icon",
                                                                                        {
                                                                                          attrs: {
                                                                                            type:
                                                                                              "delete"
                                                                                          }
                                                                                        }
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            _vm
                                                                                              .language[
                                                                                              "common.delete"
                                                                                            ]
                                                                                          )
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "a-menu-item",
                                                                                {
                                                                                  on: {
                                                                                    click: function(
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.handleMoreOperation(
                                                                                        id,
                                                                                        "img",
                                                                                        col
                                                                                      )
                                                                                    }
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    [
                                                                                      _c(
                                                                                        "a-icon",
                                                                                        {
                                                                                          attrs: {
                                                                                            type:
                                                                                              "bars"
                                                                                          }
                                                                                        }
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            _vm
                                                                                              .language[
                                                                                              "common.more"
                                                                                            ]
                                                                                          )
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ]
                                                                  ],
                                                                  2
                                                                )
                                                              ]
                                                            : _vm._e()
                                                        }
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          attrs: {
                                                            hidden:
                                                              _vm.uploadValues[
                                                                id
                                                              ] != null
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "a-tooltip",
                                                            _vm._b(
                                                              {},
                                                              "a-tooltip",
                                                              _vm.buildTooltipProps(
                                                                row,
                                                                col,
                                                                id
                                                              ),
                                                              false
                                                            ),
                                                            [
                                                              _c(
                                                                "a-upload",
                                                                _vm._b(
                                                                  {
                                                                    attrs: {
                                                                      name:
                                                                        "file",
                                                                      data: {
                                                                        isup: 1
                                                                      },
                                                                      multiple: false,
                                                                      action: _vm.getUploadAction(
                                                                        col.action
                                                                      ),
                                                                      headers: _vm.uploadGetHeaders(
                                                                        row,
                                                                        col
                                                                      ),
                                                                      showUploadList: false,
                                                                      beforeUpload:
                                                                        _vm.beforeUpload
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        v
                                                                      ) {
                                                                        return _vm.handleChangeUpload(
                                                                          v,
                                                                          id,
                                                                          row,
                                                                          col
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  "a-upload",
                                                                  _vm.buildProps(
                                                                    row,
                                                                    col
                                                                  ),
                                                                  false
                                                                ),
                                                                [
                                                                  _c(
                                                                    "a-button",
                                                                    {
                                                                      attrs: {
                                                                        icon:
                                                                          "upload"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm
                                                                            .language[
                                                                            "common.uploadPicture"
                                                                          ]
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    2
                                                  )
                                                : col.type ===
                                                  _vm.formTypes.radio
                                                ? [
                                                    _c(
                                                      "a-tooltip",
                                                      _vm._b(
                                                        {},
                                                        "a-tooltip",
                                                        _vm.buildTooltipProps(
                                                          row,
                                                          col,
                                                          id
                                                        ),
                                                        false
                                                      ),
                                                      [
                                                        _c(
                                                          "a-radio-group",
                                                          _vm._b(
                                                            {
                                                              key: i,
                                                              attrs: {
                                                                id: id,
                                                                value:
                                                                  _vm
                                                                    .radioValues[
                                                                    id
                                                                  ]
                                                              },
                                                              on: {
                                                                change: function(
                                                                  e
                                                                ) {
                                                                  return _vm.handleRadioChange(
                                                                    e.target
                                                                      .value,
                                                                    id,
                                                                    row,
                                                                    col
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            "a-radio-group",
                                                            _vm.buildProps(
                                                              row,
                                                              col
                                                            ),
                                                            false
                                                          ),
                                                          _vm._l(
                                                            col.options,
                                                            function(
                                                              item,
                                                              key
                                                            ) {
                                                              return _c(
                                                                "a-radio",
                                                                {
                                                                  key: key,
                                                                  attrs: {
                                                                    value:
                                                                      item.value
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.text
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                : col.type ===
                                                  _vm.formTypes.list_multi
                                                ? [
                                                    _c(
                                                      "a-tooltip",
                                                      _vm._b(
                                                        {},
                                                        "a-tooltip",
                                                        _vm.buildTooltipProps(
                                                          row,
                                                          col,
                                                          id
                                                        ),
                                                        false
                                                      ),
                                                      [
                                                        _vm.isEditRow(row, col)
                                                          ? _c(
                                                              "a-select",
                                                              _vm._b(
                                                                {
                                                                  key: i,
                                                                  staticStyle: {
                                                                    width:
                                                                      "100%"
                                                                  },
                                                                  attrs: {
                                                                    id: id,
                                                                    showSearch:
                                                                      "",
                                                                    "filter-option":
                                                                      _vm.filterOption,
                                                                    optionFilterProp:
                                                                      "children",
                                                                    mode:
                                                                      "multiple",
                                                                    maxTagCount: 1,
                                                                    value:
                                                                      _vm
                                                                        .multiSelectValues[
                                                                        id
                                                                      ],
                                                                    options:
                                                                      col.options,
                                                                    getPopupContainer:
                                                                      _vm.getParentContainer,
                                                                    placeholder: _vm.replaceProps(
                                                                      col,
                                                                      col.placeholder
                                                                    ),
                                                                    allowClear:
                                                                      ""
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      v
                                                                    ) {
                                                                      return _vm.handleMultiSelectChange(
                                                                        v,
                                                                        id,
                                                                        row,
                                                                        col
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                "a-select",
                                                                _vm.buildProps(
                                                                  row,
                                                                  col
                                                                ),
                                                                false
                                                              )
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "j-td-span no-edit",
                                                                class: {
                                                                  disabled: _vm.buildProps(
                                                                    row,
                                                                    col
                                                                  ).disabled
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleEditRow(
                                                                      row,
                                                                      col
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getSelectTranslateText(
                                                                      _vm
                                                                        .multiSelectValues[
                                                                        id
                                                                      ],
                                                                      row,
                                                                      col
                                                                    )
                                                                  ) +
                                                                    "\n                      "
                                                                )
                                                              ]
                                                            )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                : col.type ===
                                                  _vm.formTypes.sel_search
                                                ? [
                                                    _c(
                                                      "a-tooltip",
                                                      _vm._b(
                                                        {},
                                                        "a-tooltip",
                                                        _vm.buildTooltipProps(
                                                          row,
                                                          col,
                                                          id
                                                        ),
                                                        false
                                                      ),
                                                      [
                                                        _vm.isEditRow(row, col)
                                                          ? _c(
                                                              "a-select",
                                                              _vm._b(
                                                                {
                                                                  key: i,
                                                                  staticStyle: {
                                                                    width:
                                                                      "100%"
                                                                  },
                                                                  attrs: {
                                                                    id: id,
                                                                    showSearch:
                                                                      "",
                                                                    optionFilterProp:
                                                                      "children",
                                                                    filterOption:
                                                                      _vm.filterOption,
                                                                    value:
                                                                      _vm
                                                                        .searchSelectValues[
                                                                        id
                                                                      ],
                                                                    options:
                                                                      col.options,
                                                                    getPopupContainer:
                                                                      _vm.getParentContainer,
                                                                    placeholder: _vm.replaceProps(
                                                                      col,
                                                                      col.placeholder
                                                                    ),
                                                                    allowClear:
                                                                      ""
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      v
                                                                    ) {
                                                                      return _vm.handleSearchSelectChange(
                                                                        v,
                                                                        id,
                                                                        row,
                                                                        col
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                "a-select",
                                                                _vm.buildProps(
                                                                  row,
                                                                  col
                                                                ),
                                                                false
                                                              )
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "j-td-span no-edit",
                                                                class: {
                                                                  disabled: _vm.buildProps(
                                                                    row,
                                                                    col
                                                                  ).disabled
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleEditRow(
                                                                      row,
                                                                      col
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getSelectTranslateText(
                                                                      _vm
                                                                        .searchSelectValues[
                                                                        id
                                                                      ],
                                                                      row,
                                                                      col
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                : col.type ===
                                                  _vm.formTypes.sel_search_async
                                                ? [
                                                    _c(
                                                      "a-tooltip",
                                                      _vm._b(
                                                        {},
                                                        "a-tooltip",
                                                        _vm.buildTooltipProps(
                                                          row,
                                                          col,
                                                          id
                                                        ),
                                                        false
                                                      ),
                                                      [
                                                        _vm.isEditRow(row, col)
                                                          ? _c(
                                                              "j-search-select-tag",
                                                              _vm._b(
                                                                {
                                                                  key: i,
                                                                  staticStyle: {
                                                                    width:
                                                                      "100%"
                                                                  },
                                                                  attrs: {
                                                                    id: id,
                                                                    value:
                                                                      _vm
                                                                        .searchSelectAsyncValues[
                                                                        id
                                                                      ],
                                                                    placeholder: _vm.replaceProps(
                                                                      col,
                                                                      col.placeholder
                                                                    ),
                                                                    dict:
                                                                      col.dict,
                                                                    async: true,
                                                                    getPopupContainer:
                                                                      _vm.getParentContainer
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      v
                                                                    ) {
                                                                      return _vm.handleSearchSelectAsyncChange(
                                                                        v,
                                                                        id,
                                                                        row,
                                                                        col
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                "j-search-select-tag",
                                                                _vm.buildProps(
                                                                  row,
                                                                  col
                                                                ),
                                                                false
                                                              )
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "j-td-span no-edit",
                                                                class: {
                                                                  disabled: _vm.buildProps(
                                                                    row,
                                                                    col
                                                                  ).disabled
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleEditRow(
                                                                      row,
                                                                      col
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .searchSelectAsyncValues[
                                                                      id
                                                                    ]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                : col.type ===
                                                  _vm.formTypes.slot
                                                ? _c(
                                                    "div",
                                                    { key: i },
                                                    [
                                                      _c(
                                                        "a-tooltip",
                                                        _vm._b(
                                                          {},
                                                          "a-tooltip",
                                                          _vm.buildTooltipProps(
                                                            row,
                                                            col,
                                                            id
                                                          ),
                                                          false
                                                        ),
                                                        [
                                                          _vm._t(
                                                            col.slot ||
                                                              col.slotName ||
                                                              col.key,
                                                            null,
                                                            {
                                                              index: rowIndex,
                                                              text:
                                                                _vm.slotValues[
                                                                  id
                                                                ],
                                                              value:
                                                                _vm.slotValues[
                                                                  id
                                                                ],
                                                              column: col,
                                                              rowId: _vm.getCleanId(
                                                                row.id
                                                              ),
                                                              getValue: function() {
                                                                return _vm._getValueForSlot(
                                                                  row.id
                                                                )
                                                              },
                                                              caseId:
                                                                _vm.caseId,
                                                              allValues: _vm._getAllValuesForSlot(),
                                                              target: _vm.getVM(),
                                                              handleChange: function(
                                                                v
                                                              ) {
                                                                return _vm.handleChangeSlotCommon(
                                                                  v,
                                                                  id,
                                                                  row,
                                                                  col
                                                                )
                                                              },
                                                              isNotPass: _vm.notPassedIds.includes(
                                                                col.key + row.id
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "span",
                                                    _vm._b(
                                                      {
                                                        key: i,
                                                        staticClass:
                                                          "comp-normal",
                                                        attrs: {
                                                          title:
                                                            _vm.inputValues[
                                                              rowIndex
                                                            ][col.key]
                                                        }
                                                      },
                                                      "span",
                                                      _vm.buildProps(row, col),
                                                      false
                                                    ),
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.inputValues[
                                                            rowIndex
                                                          ][col.key]
                                                        )
                                                      )
                                                    ]
                                                  )
                                            ]
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  })
                                ],
                                2
                              )
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  ),
                  _vm.showStatisticsRow
                    ? _c(
                        "div",
                        {
                          staticClass: "tr",
                          style: Object.assign(
                            {},
                            _vm.buildTrStyle(_vm.rows.length),
                            { height: "32px" }
                          )
                        },
                        [
                          _vm.dragSort
                            ? _c("div", {
                                staticClass: "td td-ds",
                                style: _vm.style.tdLeft
                              })
                            : _vm._e(),
                          _vm.rowSelection
                            ? _c(
                                "div",
                                {
                                  staticClass: "td td-cb",
                                  style: _vm.style.tdLeft
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.language["common.sum"])
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.rowNumber
                            ? _c(
                                "div",
                                {
                                  staticClass: "td td-num",
                                  style: _vm.style.tdLeft
                                },
                                [
                                  !_vm.rowSelection
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.language["common.sum"])
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              )
                            : _vm._e(),
                          _vm._l(_vm.columns, function(col) {
                            return [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: col.type !== _vm.formTypes.hidden,
                                      expression:
                                        "col.type !== formTypes.hidden"
                                    }
                                  ],
                                  key: col.key,
                                  staticClass: "td",
                                  style: _vm.buildTdStyle(col)
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            col.type ===
                                            _vm.formTypes.inputNumber,
                                          expression:
                                            "col.type === formTypes.inputNumber"
                                        }
                                      ],
                                      staticStyle: { padding: "0 5px" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.statisticsColumns[col.key])
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _c("j-file-pop", {
            ref: "filePopView",
            attrs: {
              uploadSource: _vm.uploadSource,
              maxSize: _vm.maxSize,
              newWindowOpen: true,
              number: _vm.number,
              disabled: true,
              multiple: _vm.isShowDownloadButton
            },
            on: { ok: _vm.handleFileSuccess }
          }),
          _c("j-file-pop", {
            ref: "filePop",
            attrs: {
              uploadSource: _vm.uploadSource,
              maxSize: _vm.maxSize,
              newWindowOpen: true,
              number: _vm.number,
              disabled: _vm.disabled,
              multiple: _vm.isShowDownloadButton
            },
            on: { ok: _vm.handleFileSuccess }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }